module.exports = __webpack_public_path__ + "img/9_98.a916f302.png";